export default "__VITE_ASSET__B6tBfu$c__"